import { MatDialogConfig } from '@angular/material/dialog';
import { CreateOrderDialogData } from './create-order.component';

export const CREATE_ORDER_PANEL_CLASS = 'create-order-panel';

export function buildCreateOrderDialogConfig(
  data: CreateOrderDialogData,
  options?: { disableClose?: boolean }
): MatDialogConfig<CreateOrderDialogData> {
  return {
    width: '520px',
    maxWidth: '94vw',
    panelClass: CREATE_ORDER_PANEL_CLASS,
    autoFocus: false,
    disableClose: options?.disableClose ?? false,
    data
  };
}
